export default {
  "content": "<circle cx=\"7.5\" cy=\"7.5\" r=\"7.5\" fill=\"#333\"/><path fill=\"#fff\" d=\"M11.06 4.705L10.36 4 7.594 6.795 4.827 4l-.698.705L6.896 7.5l-2.767 2.795.698.705 2.767-2.795L10.361 11l.698-.705L8.292 7.5l2.767-2.795z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "15",
    "height": "15",
    "fill": "none",
    "viewBox": "0 0 15 15"
  }
};